<div class="confirm-modal p-4">
  <h3> {{data?.title}} </h3>
  @if (data?.message) {
    <span class="dialog-header">
      {{data?.message}}
    </span>
  }
  <div class="buttons d-flex justify-content-center">
    <button [ngClass]="{'radius-button': data?.onlyConfirm}" class="round-button button-text main m-2 mt-5"
    mat-flat-button color="primary" (click)="onClose(true)">{{data?.onlyConfirm ? 'OK': 'Yes'}}</button>
    @if (!data?.onlyConfirm) {
      <button class="round-button button-text m-2 mt-5" mat-stroked-button
      (click)="onClose(false)">No</button>
    }
  </div>
</div>
